import {
  ButtonRoomControl,
  type ButtonRoomControlProps,
} from '@/components/ButtonRoomControl'
import { useSelfMemberState } from '@/hooks/useSelfMemberState'
import { useRoomStore, useRoomStoreActions } from '@/stores/room'

type OmittedProps = Omit<ButtonRoomControlProps, 'isActive' | 'onClick' | 'tag'>

type ButtonVideoProps = OmittedProps

const ButtonVideo = ({
  disabled = false,
  isVisible = true,
  ...props
}: ButtonVideoProps) => {
  const memberId = useRoomStore(state => state.memberId)
  const selfVideoMuted = useSelfMemberState({
    subscriptionKey: 'videoMuted',
  })

  const { videoMuteHandler } = useRoomStoreActions()

  return (
    <ButtonRoomControl
      disabled={disabled}
      isActive={!selfVideoMuted}
      isVisible={isVisible}
      onClick={() => videoMuteHandler(memberId)}
      tag={disabled ? 'videocam-off' : 'videocam'}
      {...props}
    >
      Video
    </ButtonRoomControl>
  )
}

export { ButtonVideo }
